import React from "react";
import PropTypes from "prop-types";

const CommonInput = ({ autoComplete = "off", ...props }) => {
  return (
    <input
      {...props}
      autoComplete={autoComplete}
      spellCheck={false}
      data-form-type="other"
    />
  );
};

CommonInput.propTypes = {
  autoComplete: PropTypes.string
};

export default CommonInput;
